exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue__time-picker input.display-time{display:block!important;width:100%!important;height:calc(1.6em + .75rem + 2px)!important;padding:.375rem .75rem!important;font-size:.9rem!important;font-weight:400!important;line-height:1.6!important;color:#495057!important;background-color:#fff!important;background-clip:padding-box!important;border:1px solid #ced4da!important;border-radius:.25rem!important;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out!important}.form-check{margin-bottom:0}", ""]);

// exports
